import { useCallback, useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useMobileApp = () => {
  const { t } = useLocale();
  const { sendAppShare, showAlert } = useService("Misc");
  const { isValidMobile, isValidEmail } = useService("Validation");
  const [activeDownloadState, setactiveDownloadState] = useState("mobile");
  const [receiver, setreceiver] = useState<string>("");

  const shareApp = useCallback(async () => {
    let error = false,
      errorMsg = "",
      shareObject = {
        to: receiver,
        type: activeDownloadState === "mobile" ? "sms" : "email",
      };
    if (activeDownloadState === "mobile") {
      if (!isValidMobile(receiver)) {
        error = true;
        errorMsg = t("errorMsg.validate.mobile");
      }
    } else if (!isValidEmail(receiver)) {
      error = true;
      errorMsg = t("errorMsg.validate.email");
    }
    if (!error) {
      const result = await sendAppShare(shareObject);
      if (result.status) {
        setreceiver("");
        showAlert({
          type: "info",
          msg:
            shareObject.type === "email"
              ? t("errorMsg.fail.sendAppMobile")
              : t("errorMsg.fail.sendAppLinkMobile"),
        });
      } else showAlert({ type: "error", msg: t("errorMsg.fail.sendAppLink") });
    } else showAlert({ type: "error", msg: errorMsg });
  }, [
    activeDownloadState,
    isValidEmail,
    isValidMobile,
    receiver,
    sendAppShare,
    showAlert,
    t,
  ]);

  const setReceiverData = (e) => setreceiver(e.target.value);

  const selectSharingMedium = (e) => {
    setactiveDownloadState(e);
    setreceiver("");
  };
  return {
    selectSharingMedium,
    activeDownloadState,
    receiver,
    setReceiverData,
    shareApp,
  };
};
